/**
 * This is the confirmation routes configuration.
 * Only configure routes in this file.
 * @memberOf confirmation Module
 * @namespace confirmation Routes
 */
import twofaConfirmationTemplate from './2fa.confirmation.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf sce Module.confirmation Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the sce state and assign the template and controller. */

	$stateProvider
		.state('login.2fa.confirmation', {
			url: '/confirmation',
			template: twofaConfirmationTemplate,
			controller: 'twofaConfirmationController',
			controllerAs: 'vm'
		});

}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/confirmation/2fa.confirmation.route.js